(() => {
(()=>{
    if (window.__syncPromoHeightsRegistered) return;
    window.__syncPromoHeightsRegistered = true;
    function syncPromoHeights(root) {
        const scope = root || document;
        scope.querySelectorAll('.product-list').forEach((listEl)=>{
            const cards = listEl.querySelectorAll('.product-card');
            if (!cards.length) return;
            const firstCard = cards[0];
            const cardHeight = firstCard.offsetHeight;
            if (!cardHeight) return;
            // Build a flat list of visible items (products + promos) with their top positions
            const items = [];
            Array.prototype.forEach.call(listEl.children, (child)=>{
                if (!child.matches('.product-card, .product-list__promo')) return;
                const rect = child.getBoundingClientRect();
                if (!rect || !rect.height) return;
                items.push({
                    el: child,
                    type: child.classList.contains('product-list__promo') ? 'promo' : 'product',
                    top: rect.top
                });
            });
            if (!items.length) return;
            // Group items into visual rows by similar top coordinate
            items.sort((a, b)=>a.top - b.top);
            const rows = [];
            let currentRow = [];
            let currentTop = null;
            const threshold = 4; // px tolerance between items in same row
            items.forEach((item)=>{
                if (currentTop === null || Math.abs(item.top - currentTop) <= threshold) {
                    currentRow.push(item);
                    if (currentTop === null) currentTop = item.top;
                } else {
                    rows.push(currentRow);
                    currentRow = [
                        item
                    ];
                    currentTop = item.top;
                }
            });
            if (currentRow.length) rows.push(currentRow);
            // Determine which promos are in rows that contain only promos
            const promoOnlyPromos = new Set();
            rows.forEach((row)=>{
                const hasProduct = row.some((item)=>item.type === 'product');
                if (!hasProduct) row.forEach((item)=>{
                    if (item.type === 'promo') promoOnlyPromos.add(item.el);
                });
            });
            // Reset previous promo content min-heights.
            listEl.querySelectorAll('.product-list__promo .content-box').forEach((boxEl)=>{
                boxEl.style.minHeight = '';
            });
            // Apply min-height only to promos in promo-only rows.
            promoOnlyPromos.forEach((promoEl)=>{
                const size = promoEl.getAttribute('data-promo-size') || '1_1';
                const parts = size.split('_');
                const rowsSpan = parseInt(parts[1], 10) || 1;
                const targetHeight = cardHeight * rowsSpan;
                const boxEl = promoEl.querySelector('.content-box');
                if (boxEl) boxEl.style.minHeight = `${targetHeight}px`;
                else promoEl.style.minHeight = `${targetHeight}px`;
            });
        });
    }
    let resizeRaf;
    let cardsObserver = null;
    document.addEventListener('DOMContentLoaded', ()=>{
        syncPromoHeights();
        // Debounced resize handler to avoid layout thrashing
        window.addEventListener('resize', ()=>{
            if (resizeRaf) cancelAnimationFrame(resizeRaf);
            resizeRaf = requestAnimationFrame(()=>{
                syncPromoHeights();
            });
        });
        // Observe product card size changes and resync when they change
        if ('ResizeObserver' in window && !cardsObserver) {
            cardsObserver = new ResizeObserver((entries)=>{
                // If any observed product card changes size, resync heights once
                if (!entries.length) return;
                syncPromoHeights();
            });
            document.querySelectorAll('.product-list .product-card').forEach((card)=>{
                cardsObserver.observe(card);
            });
        }
    });
    document.addEventListener('shopify:section:load', (event)=>{
        if (!event.target.querySelector('.product-list')) return;
        syncPromoHeights(event.target);
        // Start observing newly added product cards as well
        if (cardsObserver) event.target.querySelectorAll('.product-list .product-card').forEach((card)=>{
            cardsObserver.observe(card);
        });
    });
    // Recalculate heights when a section or block is selected in the theme editor
    document.addEventListener('shopify:section:select', (event)=>{
        if (!event.target.querySelector('.product-list')) return;
        syncPromoHeights(event.target);
    });
    document.addEventListener('shopify:block:select', (event)=>{
        const section = event.target.closest('.shopify-section');
        if (!section || !section.querySelector('.product-list')) return;
        syncPromoHeights(section);
    });
})();


(()=>{
    const SELECTORS = {
        button: '#find-in-store-button',
        drawer: '#find-in-store-drawer',
        locationsContainer: '#locations-container',
        locationTemplate: '#drawer-location-template',
        locationBlock: '.find-in-store-drawer__location-block',
        stockIcon: '.find-in-store-drawer__location-header__stock__icon',
        stockText: '.find-in-store-drawer__location-header__stock__text',
        favouriteButton: '.find-in-store-drawer__location-button',
        searchWrapper: '.find-in-store-drawer__search',
        searchInput: '.find-in-store-drawer__block__search-input',
        searchClear: '.find-in-store-drawer__search-clear',
        searchSuggestions: '.find-in-store-drawer__search-suggestions',
        searchSuggestion: '.find-in-store-drawer__search-suggestion',
        inStockCheckbox: '.find-in-store-drawer__block__checkbox',
        drawerSizeRadios: 'input[name="drawer-radio"]'
    };
    const FUNCTIONS_BASE = 'https://netlify.blacklemon.dk/.netlify/functions';
    const ENDPOINTS = {
        locations: (store)=>`${FUNCTIONS_BASE}/getAllLocationsWithMetafield?store=${encodeURIComponent(store)}`,
        inventory: (store, prodId)=>`${FUNCTIONS_BASE}/getProductInventoryLevels?store=${encodeURIComponent(store)}&prodId=${encodeURIComponent(prodId)}`
    };
    const STORAGE_KEYS = {
        favouriteStore: 'favouriteStore',
        inStockOnly: 'findInStoreInStockOnly'
    };
    function $(root, selector) {
        return root.querySelector(selector);
    }
    function $all(root, selector) {
        return Array.from(root.querySelectorAll(selector));
    }
    function parseIntSafe(value, fallback = 0) {
        const n = Number.parseInt(value, 10);
        return Number.isFinite(n) ? n : fallback;
    }
    function getMetafieldValue(edges, key) {
        const edge = edges?.find((e)=>e?.node?.key === key);
        return edge?.node?.value ?? '';
    }
    function debounce(fn, delayMs) {
        let t;
        return (...args)=>{
            window.clearTimeout(t);
            t = window.setTimeout(()=>fn(...args), delayMs);
        };
    }
    // Great-circle (linear) distance in km between two coordinates.
    function haversineKm(lat1, lng1, lat2, lng2) {
        if (![
            lat1,
            lng1,
            lat2,
            lng2
        ].every(Number.isFinite)) return Infinity;
        const R = 6371; // Earth radius in km
        const toRad = (deg)=>deg * Math.PI / 180;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
        return 2 * R * Math.asin(Math.sqrt(a));
    }
    // Install Google's dynamic-library bootstrap so `google.maps.importLibrary`
    // exists (required by Places API New). Idempotent — the real API overrides
    // the stub once the script finishes loading. Mirrors Google's official loader.
    function loadGoogleMaps(apiKey) {
        const google = window.google || (window.google = {});
        const maps = google.maps || (google.maps = {});
        if (maps.importLibrary) return; // already bootstrapped (or fully loaded)
        const libraries = new Set();
        let loadPromise;
        const startLoad = ()=>{
            if (loadPromise) return loadPromise;
            loadPromise = new Promise((resolve, reject)=>{
                const params = new URLSearchParams({
                    key: apiKey,
                    v: 'weekly',
                    language: 'da',
                    region: 'DK',
                    libraries: [
                        ...libraries
                    ].join(','),
                    callback: 'google.maps.__findInStoreMapsCb__'
                });
                maps.__findInStoreMapsCb__ = resolve;
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
                script.async = true;
                script.onerror = ()=>reject(new Error('Google Maps could not load.'));
                document.head.appendChild(script);
            });
            return loadPromise;
        };
        // Stub: queue the requested library, trigger the load, then defer to the
        // real importLibrary the API installs on top of this one.
        maps.importLibrary = (name)=>{
            libraries.add(name);
            return startLoad().then(()=>maps.importLibrary(name));
        };
    }
    function escapeCss(value) {
        // `CSS.escape` is widely supported on modern browsers, but keep a safe fallback.
        if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
        return String(value).replace(/["\\#.:,[\]()>+~*^$|=\s]/g, '\\$&');
    }
    // Render plain-text lines into `el`, separated by real <br> elements.
    // Avoids injecting metafield/address strings as unsanitized HTML.
    function setTextLines(el, lines) {
        el.replaceChildren();
        lines.forEach((line, i)=>{
            if (i > 0) el.appendChild(document.createElement('br'));
            el.appendChild(document.createTextNode(String(line)));
        });
    }
    class FindInStoreDrawer {
        constructor(){
            this.button = document.querySelector(SELECTORS.button);
            this.drawer = document.querySelector(SELECTORS.drawer);
            if (!this.button || !this.drawer) {
                this.disabled = true;
                return;
            }
            this.store = this.drawer.getAttribute('data-store') || '';
            this.prodId = this.drawer.getAttribute('data-prod-id') || '';
            this.initialVariantId = this.drawer.getAttribute('data-default-variant-id') || '';
            this.mapsApiKey = this.drawer.getAttribute('data-maps-api-key') || '';
            // The main variant picker derives its size container class from the
            // (localized) option name, e.g. `variant-picker__option-values--størrelse`.
            // Liquid passes us that suffix so we can find and sync with the real picker
            // regardless of store language. Falls back to "size" if not provided.
            const sizeOptionType = this.drawer.getAttribute('data-size-option-type') || 'size';
            this.mainSizeContainerSelector = `.product-info__block-item .variant-picker__option-values--${sizeOptionType}`;
            this.levelOut = parseIntSafe(this.drawer.getAttribute('data-out-of-stock-threshold'), 0);
            this.levelLow = parseIntSafe(this.drawer.getAttribute('data-low-stock-threshold'), 5);
            this.stockText = {
                in: this.drawer.getAttribute('data-in-stock-text') || 'In stock',
                low: this.drawer.getAttribute('data-low-stock-text') || 'Low stock',
                out: this.drawer.getAttribute('data-out-of-stock-text') || 'Out of stock'
            };
            this.inventoryByVariantId = new Map(); // variantId -> { inventory_quantities: [...] }
            this.observer = null;
            // All listeners are registered with this signal so destroy() can remove
            // them in one shot (see the theme-editor lifecycle handling at the bottom).
            this.abortController = new AbortController();
            this.signal = this.abortController.signal;
            this.syncMainToDrawerDebounced = debounce(()=>this.syncMainToDrawer(), 50);
        }
        init() {
            if (this.disabled) return;
            this.bindUIEvents();
            this.restoreInStockOnly();
            this.setupMainVariantSync();
            this.setupAddressSearch();
            // Load locations + inventory in parallel, then paint initial stock once DOM exists.
            Promise.all([
                this.loadLocations(),
                this.loadInventory()
            ]).then(()=>{
                const variantId = this.initialVariantId;
                if (variantId) this.renderStockForVariant(variantId);
                this.applyInStockOnlyFilter();
            }).catch((err)=>{
                console.error('[find-in-store] init failed', err);
            });
        }
        bindUIEvents() {
            // Favourite store selection (event delegation)
            this.drawer.addEventListener('click', (e)=>{
                const btn = e.target?.closest?.(SELECTORS.favouriteButton);
                if (!btn) return;
                this.toggleFavourite(btn);
            }, {
                signal: this.signal
            });
            // In-stock-only filter checkbox
            document.addEventListener('change', (e)=>{
                if (!e.target?.matches?.(SELECTORS.inStockCheckbox)) return;
                // Persist the choice so it carries across products for this session.
                if (e.target.checked) window.sessionStorage.setItem(STORAGE_KEYS.inStockOnly, 'true');
                else window.sessionStorage.removeItem(STORAGE_KEYS.inStockOnly);
                this.applyInStockOnlyFilter();
            }, {
                signal: this.signal
            });
            // Variant change event (from theme)
            document.addEventListener('variant-changed', (e)=>{
                const variantId = e?.detail?.variantId;
                if (!variantId) return;
                this.renderStockForVariant(String(variantId));
                this.applyInStockOnlyFilter();
            }, {
                signal: this.signal
            });
        }
        async setupAddressSearch() {
            const input = this.drawer.querySelector(SELECTORS.searchInput);
            const list = this.drawer.querySelector(SELECTORS.searchSuggestions);
            const wrapper = this.drawer.querySelector(SELECTORS.searchWrapper);
            const clearBtn = this.drawer.querySelector(SELECTORS.searchClear);
            // Markup is only rendered when a Maps API key is configured.
            if (!input || !list || !this.mapsApiKey) return;
            // Swap the search icon for the clear (close) icon once the field has text.
            const syncClearButton = ()=>{
                if (wrapper) wrapper.classList.toggle('has-value', input.value.trim().length > 0);
            };
            // Clearing resets the field and restores the default location order.
            const clearSearch = ()=>{
                input.value = '';
                list.replaceChildren();
                list.hidden = true;
                syncClearButton();
                this.resetLocationOrder();
                input.focus();
            };
            if (clearBtn) clearBtn.addEventListener('click', clearSearch, {
                signal: this.signal
            });
            input.addEventListener('input', ()=>{
                syncClearButton();
                // Emptying the field manually (backspace/cut) also restores the default order.
                if (input.value.trim().length === 0) this.resetLocationOrder();
            }, {
                signal: this.signal
            });
            let places;
            try {
                loadGoogleMaps(this.mapsApiKey);
                // Places API (New) — Data API lets us keep our own input + dropdown.
                places = await window.google.maps.importLibrary('places');
            } catch (err) {
                console.error('[find-in-store] Google Maps failed to load', err);
                return;
            }
            const { AutocompleteSessionToken: AutocompleteSessionToken, AutocompleteSuggestion: AutocompleteSuggestion } = places;
            // A session token groups keystrokes + the final selection into one
            // billable session. A fresh token is started after each selection.
            let sessionToken = new AutocompleteSessionToken();
            let predictions = [];
            let activeIndex = -1;
            const closeList = ()=>{
                list.replaceChildren();
                list.hidden = true;
                predictions = [];
                activeIndex = -1;
            };
            const selectPrediction = async (prediction)=>{
                if (!prediction) return;
                try {
                    const place = prediction.toPlace();
                    await place.fetchFields({
                        fields: [
                            'location',
                            'formattedAddress'
                        ],
                        sessionToken: sessionToken
                    });
                    input.value = place.formattedAddress || prediction.text?.toString() || input.value;
                    syncClearButton();
                    closeList();
                    sessionToken = new AutocompleteSessionToken();
                    const location = place.location;
                    if (location) this.sortLocationsByDistance(location.lat(), location.lng());
                } catch (err) {
                    console.error('[find-in-store] place lookup failed', err);
                }
            };
            const setActive = (next)=>{
                const items = $all(list, SELECTORS.searchSuggestion);
                if (items.length === 0) return;
                activeIndex = (next + items.length) % items.length;
                items.forEach((el, i)=>el.classList.toggle('is-active', i === activeIndex));
            };
            const renderSuggestions = (suggestions)=>{
                predictions = suggestions.map((s)=>s.placePrediction).filter(Boolean);
                activeIndex = -1;
                if (predictions.length === 0) {
                    closeList();
                    return;
                }
                list.replaceChildren(...predictions.map((prediction)=>{
                    const li = document.createElement('li');
                    li.className = 'find-in-store-drawer__search-suggestion';
                    li.setAttribute('role', 'option');
                    li.textContent = prediction.text?.toString() || '';
                    // mousedown (not click) fires before the input loses focus.
                    li.addEventListener('mousedown', (e)=>{
                        e.preventDefault();
                        selectPrediction(prediction);
                    });
                    return li;
                }));
                list.hidden = false;
            };
            const fetchSuggestions = async ()=>{
                const value = input.value.trim();
                if (value.length < 2) {
                    closeList();
                    return;
                }
                try {
                    const { suggestions: suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                        input: value,
                        includedRegionCodes: [
                            'dk'
                        ],
                        language: 'da',
                        region: 'dk',
                        sessionToken: sessionToken
                    });
                    renderSuggestions(suggestions || []);
                } catch (err) {
                    console.error('[find-in-store] autocomplete failed', err);
                }
            };
            input.addEventListener('input', debounce(fetchSuggestions, 250), {
                signal: this.signal
            });
            input.addEventListener('keydown', (e)=>{
                if (list.hidden) return;
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    setActive(activeIndex + 1);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    setActive(activeIndex - 1);
                } else if (e.key === 'Enter') {
                    e.preventDefault();
                    selectPrediction(predictions[activeIndex] ?? predictions[0]);
                } else if (e.key === 'Escape') closeList();
            }, {
                signal: this.signal
            });
            // Close the dropdown when clicking outside the search field.
            document.addEventListener('click', (e)=>{
                if (!e.target?.closest?.(SELECTORS.searchWrapper)) closeList();
            }, {
                signal: this.signal
            });
        }
        sortLocationsByDistance(lat, lng) {
            const container = document.querySelector(SELECTORS.locationsContainer);
            if (!container) return;
            const blocks = $all(container, SELECTORS.locationBlock);
            if (blocks.length === 0) return;
            blocks.map((block)=>({
                    block: block,
                    distance: haversineKm(lat, lng, Number.parseFloat(block.getAttribute('data-lat')), Number.parseFloat(block.getAttribute('data-lng')))
                })).sort((a, b)=>a.distance - b.distance)// Re-appending in sorted order reorders the existing nodes in place.
            .forEach(({ block: block })=>container.appendChild(block));
            this.pinFavouriteToTop();
        }
        async loadLocations() {
            const container = document.querySelector(SELECTORS.locationsContainer);
            const template = document.querySelector(SELECTORS.locationTemplate);
            if (!container || !template) return;
            const response = await fetch(ENDPOINTS.locations(this.store));
            const data = await response.json();
            container.innerHTML = '';
            const favouriteStore = window.localStorage.getItem(STORAGE_KEYS.favouriteStore);
            data.forEach((item)=>{
                const location = item?.node;
                if (!location) return;
                // Exclude special Shopify location name.
                if (String(location.name).toLowerCase() === 'shop location') return;
                const edges = location?.metafields?.edges || [];
                // Exclude locations explicitly hidden from the drawer.
                if (getMetafieldValue(edges, 'hide_location_from_drawer') === 'true') return;
                const customName = getMetafieldValue(edges, 'location_name') || location.name;
                const workingHours = getMetafieldValue(edges, 'location_working_hours');
                const locationPlace = getMetafieldValue(edges, 'location_place');
                const clone = template.content.cloneNode(true);
                this.fillLocationClone(clone, {
                    location: location,
                    customName: customName,
                    workingHours: workingHours,
                    locationPlace: locationPlace,
                    favouriteStore: favouriteStore
                });
                container.appendChild(clone);
            });
            // Remember the initial (server) order so we can restore it when the search is cleared.
            this.defaultLocationOrder = $all(container, SELECTORS.locationBlock);
            this.pinFavouriteToTop();
        }
        // Move the favourite store (location-selected) to the top of the list.
        pinFavouriteToTop() {
            const container = document.querySelector(SELECTORS.locationsContainer);
            if (!container) return;
            const favouriteBlock = $all(container, SELECTORS.locationBlock).find((block)=>{
                const btn = $(block, SELECTORS.favouriteButton);
                return btn?.classList.contains('location-selected');
            });
            if (favouriteBlock) container.insertBefore(favouriteBlock, container.firstChild);
        }
        // Re-append blocks in their original order, undoing any distance sort.
        resetLocationOrder() {
            const container = document.querySelector(SELECTORS.locationsContainer);
            if (!container || !this.defaultLocationOrder) return;
            this.defaultLocationOrder.forEach((block)=>container.appendChild(block));
            this.pinFavouriteToTop();
        }
        fillLocationClone(clone, { location: location, customName: customName, workingHours: workingHours, locationPlace: locationPlace, favouriteStore: favouriteStore }) {
            const block = clone.querySelector(SELECTORS.locationBlock);
            if (block) {
                block.setAttribute('data-store', location.name);
                block.setAttribute('data-lat', location?.address?.latitude ?? '');
                block.setAttribute('data-lng', location?.address?.longitude ?? '');
            }
            const nameEl = clone.querySelector('.find-in-store-drawer__location-header__name');
            if (nameEl) nameEl.textContent = customName;
            const addressEl = clone.querySelector('.find-in-store-drawer__location-address');
            if (addressEl) {
                const addressLines = [];
                if (locationPlace) addressLines.push(locationPlace);
                const addr = location.address;
                if (addr) [
                    addr.address1,
                    addr.address2,
                    [
                        addr.zip,
                        addr.city
                    ].filter(Boolean).join(' ')
                ].forEach((line)=>{
                    if (line && String(line).trim() !== '') addressLines.push(String(line));
                });
                setTextLines(addressEl, addressLines);
            }
            if (workingHours) {
                const hoursEl = clone.querySelector('.find-in-store-drawer__location-working-hours__content');
                if (hoursEl) setTextLines(hoursEl, String(workingHours).split('\n'));
            } else {
                const hoursSection = clone.querySelector('.find-in-store-drawer__location-working-hours');
                if (hoursSection) hoursSection.style.display = 'none';
            }
            const favBtn = clone.querySelector(SELECTORS.favouriteButton);
            if (favBtn && favouriteStore && favouriteStore === location.name) {
                favBtn.classList.add('location-selected');
                favBtn.textContent = favBtn.getAttribute('data-favourite-selected') || favBtn.textContent;
            }
        }
        async loadInventory() {
            if (!this.prodId) return;
            const response = await fetch(ENDPOINTS.inventory(this.store, this.prodId));
            const data = await response.json();
            data.forEach((item)=>{
                const gid = item?.id;
                if (!gid) return;
                const variantId = String(gid).split('/').pop();
                if (!variantId) return;
                this.inventoryByVariantId.set(variantId, {
                    inventory_quantities: item.inventory_quantities || []
                });
            });
        }
        getStockState(level) {
            if (level > this.levelLow) return 'in';
            if (level > this.levelOut) return 'low';
            return 'out';
        }
        renderStockForVariant(variantId) {
            const entry = this.inventoryByVariantId.get(String(variantId));
            if (!entry || !Array.isArray(entry.inventory_quantities)) return;
            entry.inventory_quantities.forEach((loc)=>{
                const storeName = loc?.name;
                if (!storeName) return;
                const block = this.drawer.querySelector(`[data-store="${escapeCss(String(storeName))}"]`);
                if (!block) return;
                const iconEl = $(block, SELECTORS.stockIcon);
                const textEl = $(block, SELECTORS.stockText);
                if (!iconEl || !textEl) return;
                const state = this.getStockState(loc?.level ?? 0);
                textEl.textContent = this.stockText[state];
                iconEl.className = `find-in-store-drawer__location-header__stock__icon find-in-store-drawer__location-header__stock__icon--${state === 'in' ? 'in-stock' : state === 'low' ? 'low-stock' : 'out-of-stock'}`;
            });
        }
        toggleFavourite(clickedButton) {
            const allButtons = $all(this.drawer, SELECTORS.favouriteButton);
            allButtons.forEach((btn)=>{
                if (btn === clickedButton) return;
                btn.classList.remove('location-selected');
                btn.textContent = btn.getAttribute('data-favourite-unselected') || btn.textContent;
            });
            clickedButton.classList.toggle('location-selected');
            const isSelected = clickedButton.classList.contains('location-selected');
            const block = clickedButton.closest(SELECTORS.locationBlock);
            const store = block?.getAttribute('data-store') || '';
            if (isSelected) {
                clickedButton.textContent = clickedButton.getAttribute('data-favourite-selected') || clickedButton.textContent;
                if (store) window.localStorage.setItem(STORAGE_KEYS.favouriteStore, store);
                this.pinFavouriteToTop();
            } else {
                clickedButton.textContent = clickedButton.getAttribute('data-favourite-unselected') || clickedButton.textContent;
                window.localStorage.removeItem(STORAGE_KEYS.favouriteStore);
                this.resetLocationOrder();
            }
        }
        // Restore the persisted "in stock only" choice so it applies on every
        // product for this session. applyInStockOnlyFilter() runs later (after
        // locations load) and reads this checkbox state.
        restoreInStockOnly() {
            const checkbox = this.drawer.querySelector(SELECTORS.inStockCheckbox);
            if (!checkbox) return;
            checkbox.checked = window.sessionStorage.getItem(STORAGE_KEYS.inStockOnly) === 'true';
        }
        applyInStockOnlyFilter() {
            const checkbox = this.drawer.querySelector(SELECTORS.inStockCheckbox);
            if (!checkbox) return;
            const blocks = $all(this.drawer, SELECTORS.locationBlock);
            const showInStockOnly = Boolean(checkbox.checked);
            blocks.forEach((block)=>{
                if (!showInStockOnly) {
                    block.style.display = 'flex';
                    return;
                }
                // Hide only if we have a rendered out-of-stock icon; if stock hasn't been rendered yet, keep it visible.
                const isOutOfStock = Boolean(block.querySelector('.find-in-store-drawer__location-header__stock__icon--out-of-stock'));
                block.style.display = isOutOfStock ? 'none' : 'flex';
            });
        }
        isDrawerOpen() {
            return this.drawer.classList.contains('is-open') || this.drawer.getAttribute('aria-hidden') === 'false';
        }
        getMainSizeContainer() {
            return document.querySelector(this.mainSizeContainerSelector);
        }
        syncMainToDrawer() {
            // Preserve drawer state while it's open.
            if (this.isDrawerOpen()) return;
            const mainContainer = this.getMainSizeContainer();
            if (!mainContainer) return;
            const mainRadios = $all(mainContainer, 'input[type="radio"]');
            const drawerRadios = $all(document, SELECTORS.drawerSizeRadios);
            mainRadios.forEach((mainRadio)=>{
                const mainLabel = mainContainer.querySelector(`label[for="${escapeCss(mainRadio.id)}"]`);
                const mainSpan = mainLabel?.querySelector?.('span');
                if (!mainLabel || !mainSpan) return;
                const sizeValue = mainSpan.textContent.trim();
                const drawerRadio = drawerRadios.find((r)=>r.value === sizeValue);
                if (!drawerRadio) return;
                drawerRadio.checked = mainRadio.checked;
                const drawerLabel = document.querySelector(`label[for="${escapeCss(drawerRadio.id)}"]`);
                if (drawerLabel) drawerLabel.classList.toggle('is-disabled', mainLabel.classList.contains('is-disabled'));
            });
        }
        setupMainVariantSync() {
            // Initial sync (delay lets theme scripts finish first).
            window.setTimeout(()=>this.syncMainToDrawer(), 100);
            document.addEventListener('change', (event)=>{
                // Main form changed -> update drawer
                if (event.target?.closest?.(this.mainSizeContainerSelector)) {
                    this.syncMainToDrawerDebounced();
                    return;
                }
                // Drawer changed -> update main form
                if (event.target?.matches?.(SELECTORS.drawerSizeRadios)) {
                    const selectedSize = event.target.value;
                    const mainContainer = this.getMainSizeContainer();
                    if (!mainContainer) return;
                    const mainRadios = $all(mainContainer, 'input[type="radio"]');
                    mainRadios.forEach((mainRadio)=>{
                        const mainLabel = mainContainer.querySelector(`label[for="${escapeCss(mainRadio.id)}"]`);
                        const mainSpan = mainLabel?.querySelector?.('span');
                        if (!mainLabel || !mainSpan) return;
                        const mainSizeText = mainSpan.textContent.trim();
                        if (mainSizeText !== selectedSize || mainRadio.checked) return;
                        mainRadio.checked = true;
                        mainRadio.dispatchEvent(new Event('change', {
                            bubbles: true
                        }));
                    });
                }
            }, {
                signal: this.signal
            });
            // Survive Shopify re-renders of the variant picker.
            this.observer = new MutationObserver((mutations)=>{
                for (const mutation of mutations){
                    // Injected HTML (theme re-rendering the form)
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        if (mutation.target?.closest?.('.product-info__block-item')) {
                            this.syncMainToDrawerDebounced();
                            return;
                        }
                    }
                    // Class changes (theme visually disabling variants)
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (mutation.target?.closest?.(this.mainSizeContainerSelector)) {
                            this.syncMainToDrawerDebounced();
                            return;
                        }
                    }
                }
            });
            // Scope the observer to the product-info container so its callback only
            // runs on variant-picker mutations, not on every DOM/class change across
            // the page (other apps, animations, sticky headers, etc.). Fall back to
            // document.body if the expected markup isn't present.
            const observeRoot = document.querySelector(this.mainSizeContainerSelector)?.closest('.product-info') || document.querySelector('.product-info') || document.body;
            this.observer.observe(observeRoot, {
                childList: true,
                attributes: true,
                subtree: true,
                attributeFilter: [
                    'class'
                ]
            });
        }
        // Detach everything this instance wired up so it can be garbage-collected
        // and won't keep firing against detached nodes after a re-render.
        destroy() {
            this.abortController?.abort();
            this.observer?.disconnect();
            this.observer = null;
        }
    }
    let instance = null;
    // (Re)create the drawer against the current DOM, tearing down any previous
    // instance first. Stays null when the markup isn't present, so a later
    // section:load can try again.
    function mount() {
        if (instance) {
            instance.destroy();
            instance = null;
        }
        const next = new FindInStoreDrawer();
        if (next.disabled) return;
        next.init();
        instance = next;
    }
    // Init immediately (theme bundles may be deferred; we don't need DOMContentLoaded for basic selectors).
    mount();
    // Theme-editor lifecycle: sections are re-rendered on every customizer edit,
    // which swaps out our markup but leaves this instance pointing at detached
    // nodes. Re-mount on load/unload so the feature keeps working (and so it
    // initialises if a merchant adds the section after the page first loaded).
    // These events only fire inside the theme editor, so storefront is unaffected.
    document.addEventListener('shopify:section:load', mount);
    document.addEventListener('shopify:section:unload', mount);
})();


/**
 * Aligns free-text search with storefront facets and category collections.
 *
 * Shopify predictive search ignores metafield filters, and semantic storefront
 * search mishandles many Danish terms left in `q` (colors AND category words
 * like "toppe"). When a query contains facet labels and/or matches a collection:
 *  1. Strip matched facet terms from `q` and apply filter.* params
 *  2. If the remaining category term matches a collection (as the drawer shows),
 *     go to that collection (with any filters) instead of /search
 *  3. Use filtered /search for the drawer when facets are detected
 *
 * Examples:
 *  - "grøn kjole" → /search?q=kjole&filter.p.m.custom.color_filter=Grøn
 *  - "blå" → /search?q=*&filter.p.m.custom.color_filter=Blå
 *  - "toppe" → /search?q=top&search_collection=toppe
 *  - "sort toppe" → /search?q=top&search_collection=toppe&filter.p.m.custom.color_filter=Sort
 */ (()=>{
    const TERMS_SCRIPT_ID = "search-filter-terms";
    const DISPLAY_QUERY_KEY = "searchDisplayQuery";
    const MIN_PHRASE_LENGTH = 3;
    // Alias token → normalizeLabel(facet label). Must match normalizeToken output.
    const LABEL_ALIASES = {
        sort: "sort",
        sorte: "sort",
        sorten: "sort",
        hvid: "hvid",
        hvide: "hvid",
        hvidt: "hvid",
        brun: "brun",
        brune: "brun",
        brunt: "brun",
        sand: "sand",
        sandfarvet: "sand",
        gra: "gra",
        graa: "gra",
        rod: "roed",
        rode: "roed",
        roed: "roed",
        roede: "roed",
        bla: "bla",
        blaa: "bla",
        blae: "bla",
        gul: "gul",
        gule: "gul",
        gult: "gul",
        gron: "groen",
        groen: "groen",
        gronne: "groen",
        groenne: "groen",
        pink: "pink",
        pinke: "pink",
        orange: "orange",
        lilla: "lilla",
        denim: "denim",
        stribet: "stribet",
        stribede: "stribet",
        print: "print",
        prikket: "prikket",
        prikkede: "prikket",
        ternet: "ternet",
        ternede: "ternet",
        bordeaux: "bordeaux"
    };
    /** @type {{ param: string, value: string, label: string, tokens: string[] }[] | null} */ let phraseIndex = null;
    let loadingIndex = null;
    function normalizeToken(token) {
        return token.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/æ/g, "ae").replace(/ø/g, "oe").replace(/å/g, "aa");
    }
    function normalizeLabel(label) {
        return normalizeToken(String(label || "").replace(/&#39;/g, "'").replace(/&amp;/g, "&"));
    }
    function decodeHtmlEntities(value) {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = value;
        return textarea.value;
    }
    function shouldIncludeFilterParam(param) {
        if (!param || param === "filter.v.availability") return false;
        if (param.startsWith("filter.v.option.")) return false;
        return param.startsWith("filter.");
    }
    function buildPhraseIndex(filters) {
        /** @type {Map<string, { param: string, value: string, label: string, tokens: string[] }>} */ const byKey = new Map();
        for (const filter of filters || []){
            if (!shouldIncludeFilterParam(filter.param)) continue;
            for (const entry of filter.values || []){
                const label = decodeHtmlEntities(entry.label || entry.value || "");
                const value = decodeHtmlEntities(entry.value || entry.label || "");
                if (!label) continue;
                const tokens = normalizeLabel(label).split(/\s+/).filter(Boolean);
                if (tokens.length === 0) continue;
                if (tokens.join("").length < MIN_PHRASE_LENGTH && tokens.length === 1) continue;
                const phrase = {
                    param: filter.param,
                    value: value,
                    label: label,
                    tokens: tokens
                };
                byKey.set(`${filter.param}::${normalizeLabel(label)}`, phrase);
                // Register Danish aliases that resolve to this label (colors etc.).
                const labelKey = tokens.join(" ");
                for (const [alias, target] of Object.entries(LABEL_ALIASES))if (target === labelKey) byKey.set(`${filter.param}::alias::${alias}`, {
                    ...phrase,
                    tokens: [
                        alias
                    ]
                });
            }
        }
        return [
            ...byKey.values()
        ].sort((a, b)=>b.tokens.length - a.tokens.length || b.tokens.join("").length - a.tokens.join("").length);
    }
    function readEmbeddedFilters() {
        const el = document.getElementById(TERMS_SCRIPT_ID);
        if (!el) return [];
        try {
            const data = JSON.parse(el.textContent || "{}");
            return Array.isArray(data.filters) ? data.filters : [];
        } catch (e) {
            return [];
        }
    }
    async function fetchFiltersFromCollection() {
        const root = window.Shopify?.routes?.root || "/";
        const html = await (await fetch(`${root}collections/all`)).text();
        /** @type {Map<string, { param: string, label: string, values: { value: string, label: string }[] }>} */ const byParam = new Map();
        const inputRe = /name="(filter\.[^"]+)"[^>]*value="([^"]+)"/gi;
        let match;
        while(match = inputRe.exec(html)){
            const param = match[1];
            const value = decodeHtmlEntities(match[2]);
            if (!shouldIncludeFilterParam(param)) continue;
            if (!byParam.has(param)) byParam.set(param, {
                param: param,
                label: param,
                values: []
            });
            const bucket = byParam.get(param);
            if (!bucket.values.some((entry)=>entry.value === value)) bucket.values.push({
                value: value,
                label: value
            });
        }
        return [
            ...byParam.values()
        ];
    }
    async function ensurePhraseIndex() {
        if (phraseIndex) return phraseIndex;
        if (loadingIndex) return loadingIndex;
        loadingIndex = (async ()=>{
            let filters = readEmbeddedFilters();
            const embeddedCount = filters.reduce((sum, filter)=>sum + (filter.values?.length || 0), 0);
            if (embeddedCount === 0) try {
                filters = await fetchFiltersFromCollection();
            } catch (e) {
                filters = [];
            }
            phraseIndex = buildPhraseIndex(filters);
            return phraseIndex;
        })();
        try {
            return await loadingIndex;
        } finally{
            loadingIndex = null;
        }
    }
    /**
   * @param {string} query
   * @param {{ param: string, value: string, label: string, tokens: string[] }[]} index
   * @returns {{ q: string, filters: { param: string, value: string, label: string }[], original: string } | null}
   */ function rewriteQuery(query, index) {
        const original = query.trim();
        const tokens = original.split(/\s+/).filter(Boolean);
        if (tokens.length === 0 || !index?.length) return null;
        // Stem Danish plurals/inflections on remaining (non-filter) tokens before
        // building the q value. Color inflections are handled by LABEL_ALIASES instead.
        const normalized = tokens.map(normalizeToken);
        const used = new Array(tokens.length).fill(false);
        /** @type {{ param: string, value: string, label: string }[]} */ const matchedFilters = [];
        const matchedParams = new Set();
        for (const phrase of index){
            if (matchedParams.has(phrase.param)) continue;
            const len = phrase.tokens.length;
            for(let i = 0; i <= normalized.length - len; i += 1){
                let ok = true;
                for(let j = 0; j < len; j += 1)if (used[i + j] || normalized[i + j] !== phrase.tokens[j]) {
                    ok = false;
                    break;
                }
                if (!ok) continue;
                for(let j = 0; j < len; j += 1)used[i + j] = true;
                matchedFilters.push({
                    param: phrase.param,
                    value: phrase.value,
                    label: phrase.label
                });
                matchedParams.add(phrase.param);
                break;
            }
        }
        if (matchedFilters.length === 0) return null;
        const remaining = tokens.filter((_, i)=>!used[i]);
        // remaining may be empty when the whole query is facet terms (e.g. "blå", "Sort")
        return {
            original: original,
            q: remaining.map(stemDanish).join(" "),
            filters: matchedFilters
        };
    }
    /**
   * Reduce common Danish plural/inflected forms to their base so Shopify's
   * English-biased stemmer can match them.
   * Examples: toppe→top, kjoler→kjole, bukser→bukse, nederdele→nederdel
   */ function stemDanish(word) {
        const w = word.toLowerCase();
        if (w.length > 4 && w.endsWith("ppe")) return word.slice(0, -2); // toppe→top
        if (w.length > 5 && w.endsWith("ele")) return word.slice(0, -1); // nederdele→nederdel
        // -ler, -ner, -ser, -ger: strip just the final -r (kjole+r, bluse+r)
        if (w.length > 5 && /[lnsgj]er$/.test(w)) return word.slice(0, -1);
        // -er after a consonant: strip -er, but preserve doubled consonant (jakker→jakke)
        if (w.length > 5 && w.endsWith("er") && /[^aeiouyæøå]er$/.test(w)) {
            const stem = word.slice(0, -2);
            // If the stem ends in a doubled consonant, the base form has one (jakk→jakke)
            if (/([b-df-hj-np-tv-z])\1$/.test(stem)) return stem + "e";
            return stem;
        }
        return word;
    }
    function buildFilteredSearchUrl(rewritten, { sectionId: sectionId = null, includeDisplayQuery: includeDisplayQuery = true, collectionHandle: collectionHandle = null } = {}) {
        const root = window.Shopify?.routes?.root || "/";
        const url = new URL(`${root}search`, window.location.origin);
        // Shopify /search with an empty q returns no results.
        // Use the wildcard "*" so all products are returned, then the facets narrow by color.
        // For drawer requests keep the original term so predictive search gets real results.
        const q = rewritten.q || (sectionId ? rewritten.original : "*");
        url.searchParams.set("q", q);
        url.searchParams.set("type", "product");
        for (const filter of rewritten.filters)url.searchParams.append(filter.param, filter.value);
        if (collectionHandle) url.searchParams.set("search_collection", collectionHandle);
        if (sectionId) url.searchParams.set("section_id", sectionId);
        if (includeDisplayQuery) try {
            sessionStorage.setItem(DISPLAY_QUERY_KEY, rewritten.original);
        } catch (e) {
        /* ignore */ }
        return url;
    }
    function collectionPath(collection) {
        const raw = collection?.url || "";
        try {
            return new URL(raw, window.location.origin).pathname;
        } catch (e) {
            return raw.split("?")[0];
        }
    }
    function collectionHandleFrom(collection) {
        const path = collectionPath(collection);
        const part = path.split("/collections/")[1] || "";
        return decodeURIComponent(part.split("/")[0].split("?")[0] || "");
    }
    function titlesLooselyMatch(query, title) {
        const a = normalizeLabel(query);
        const b = normalizeLabel(title);
        if (!a || !b) return false;
        if (a === b) return true;
        // Simple Danish plural variants: top/toppe, kjole/kjoler
        if (a + "r" === b || b + "r" === a) return true;
        if (a + "e" === b || b + "e" === a) return true;
        if (a + "er" === b || b + "er" === a) return true;
        if (a + "pe" === b || b + "pe" === a) return true; // top/toppe
        return false;
    }
    /**
   * Prefer the same collection predictive search would surface for a category term.
   * @param {string} query
   * @returns {Promise<{ title: string, url: string, handle?: string } | null>}
   */ async function findMatchingCollection(query) {
        const q = query.trim();
        if (!q) return null;
        const root = window.Shopify?.routes?.root || "/";
        const suggestUrl = `${root}search/suggest.json?q=${encodeURIComponent(q)}` + "&resources[type]=collection&resources[limit]=10&resources[limit_scope]=each";
        try {
            const data = await (await fetch(suggestUrl)).json();
            const collections = data?.resources?.results?.collections || [];
            if (!collections.length) return null;
            const exact = collections.find((collection)=>titlesLooselyMatch(q, collection.title));
            if (exact) return exact;
            const byHandle = collections.find((collection)=>{
                const handle = collectionHandleFrom(collection);
                return titlesLooselyMatch(q, handle.replace(/-/g, " ")) || titlesLooselyMatch(q, handle);
            });
            return byHandle || null;
        } catch (e) {
            return null;
        }
    }
    function buildPlainSearchUrl(q, { original: original = q, filters: filters = [], collectionHandle: collectionHandle = null } = {}) {
        const root = window.Shopify?.routes?.root || "/";
        const url = new URL(`${root}search`, window.location.origin);
        url.searchParams.set("q", q || "*");
        url.searchParams.set("type", "product");
        for (const filter of filters)url.searchParams.append(filter.param, filter.value);
        if (collectionHandle) url.searchParams.set("search_collection", collectionHandle);
        try {
            sessionStorage.setItem(DISPLAY_QUERY_KEY, original);
        } catch (e) {
        /* ignore */ }
        return url;
    }
    function isThemeSearchForm(form) {
        if (!(form instanceof HTMLFormElement)) return false;
        if (form.id === "predictive-search-form") return true;
        if (form.getAttribute("role") !== "search") return false;
        if (!form.querySelector(".search-form__input, .search-drawer__input")) return false;
        const action = form.getAttribute("action") || "";
        return action.includes("search");
    }
    async function handleSearchSubmit(form) {
        const qInput = form.elements.namedItem("q");
        if (!(qInput instanceof HTMLInputElement) && !(qInput instanceof HTMLTextAreaElement)) return false;
        const original = qInput.value.trim();
        if (!original) return false;
        const index = await ensurePhraseIndex();
        const rewritten = rewriteQuery(original, index);
        const filters = rewritten?.filters || [];
        // Pure filter-only query (e.g. "blå", "Sort") — use wildcard q=* on /search
        // so the search page renders and displays the color term correctly.
        if (rewritten && rewritten.q === "") {
            window.location.assign(buildFilteredSearchUrl(rewritten).toString());
            return true;
        }
        // Prefer a matching collection for the category part (or full query) so results
        // match catalog membership (e.g. "toppe", "blå toppe" → Toppe collection).
        const categoryQuery = rewritten?.q || original.split(/\s+/).map(stemDanish).join(" ");
        const collection = await findMatchingCollection(categoryQuery) || await findMatchingCollection(original) || null;
        const collectionHandle = collection ? collectionHandleFrom(collection) : null;
        if (rewritten) {
            window.location.assign(buildFilteredSearchUrl(rewritten, {
                collectionHandle: collectionHandle
            }).toString());
            return true;
        }
        if (collectionHandle) {
            window.location.assign(buildPlainSearchUrl(categoryQuery, {
                original: original,
                filters: filters,
                collectionHandle: collectionHandle
            }).toString());
            return true;
        }
        // No filter/collection match — stem Danish plurals for the search request
        // (toppe→top) but keep the original wording in the search bar.
        const stemmed = original.split(/\s+/).map(stemDanish).join(" ");
        if (stemmed !== original) {
            window.location.assign(buildPlainSearchUrl(stemmed, {
                original: original
            }).toString());
            return true;
        }
        return false;
    }
    function restoreDisplayQuery() {
        const input = document.querySelector('.shopify-section--main-search .search-form__input, .shopify-section--main-search input[name="q"]');
        if (!(input instanceof HTMLInputElement)) return;
        let stored = null;
        try {
            stored = sessionStorage.getItem(DISPLAY_QUERY_KEY);
            sessionStorage.removeItem(DISPLAY_QUERY_KEY);
        } catch (e) {
            stored = null;
        }
        if (stored) input.value = stored;
    }
    /**
   * When search_collection + filters are set, Liquid cannot facet the
   * collection (Shopify only applies filter.* to the primary search resource).
   * The grid is left empty until this fetch swaps in filtered collection HTML.
   */ async function hydrateSearchCollectionProducts() {
        const params = new URLSearchParams(window.location.search);
        const handle = params.get('search_collection');
        if (!handle) return;
        const section = document.querySelector('.shopify-section--main-search');
        const localInner = section?.querySelector('[data-search-collection-hydrate]');
        if (!localInner) return;
        const fallback = section.querySelector('[data-search-collection-fallback]');
        const localCount = section.querySelector('[data-search-results-count]');
        const showFallback = ()=>{
            if (fallback instanceof HTMLTemplateElement) localInner.replaceChildren(fallback.content.cloneNode(true));
            if (localCount) {
                localCount.textContent = '';
                localCount.removeAttribute('aria-busy');
            }
            localInner.removeAttribute('aria-busy');
        };
        const root = window.Shopify?.routes?.root || '/';
        const collUrl = new URL(`${root}collections/${encodeURIComponent(handle)}`, window.location.origin);
        for (const [key, value] of params.entries()){
            if (key === 'q' || key === 'type' || key === 'search_collection' || key === 'section_id') continue;
            collUrl.searchParams.append(key, value);
        }
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', {
            bubbles: true
        }));
        try {
            const html = await (await fetch(collUrl.toString(), {
                credentials: 'same-origin'
            })).text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const remoteInner = doc.querySelector('#collection .collection__inner');
            if (!remoteInner) {
                showFallback();
                return;
            }
            localInner.innerHTML = remoteInner.innerHTML;
            const remoteCount = doc.querySelector('.collection__toolbar .subheading');
            if (remoteCount && localCount && remoteCount.textContent.trim()) localCount.textContent = remoteCount.textContent.trim();
            localCount?.removeAttribute('aria-busy');
            localInner.removeAttribute('aria-busy');
        } catch (e) {
            showFallback();
        } finally{
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
                bubbles: true
            }));
        }
    }
    function supportsPredictiveApi() {
        try {
            return JSON.parse(document.getElementById("shopify-features").textContent || "{}").predictiveSearch;
        } catch (e) {
            return true;
        }
    }
    function interceptPredictiveSearchInput() {
        if (window.__searchRewritePredictiveBound) return;
        window.__searchRewritePredictiveBound = true;
        let debounceTimer = 0;
        /** @type {AbortController | null} */ let abortController = null;
        function predictiveElement() {
            return document.querySelector("predictive-search");
        }
        function showPlaceholder(el) {
            if (el?.shadowRoot) el.shadowRoot.innerHTML = '<slot name="placeholder"></slot>';
        }
        async function runPredictiveSearch(q) {
            const el = predictiveElement();
            if (!el) return;
            abortController?.abort();
            abortController = new AbortController();
            const { signal: signal } = abortController;
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", {
                bubbles: true
            }));
            try {
                const index = await ensurePhraseIndex();
                if (signal.aborted) return;
                const rewritten = rewriteQuery(q, index);
                const root = window.Shopify?.routes?.root || "/";
                const url = rewritten ? buildFilteredSearchUrl(rewritten, {
                    sectionId: "predictive-search",
                    includeDisplayQuery: false
                }) : new URL(`${root}search${supportsPredictiveApi() ? "/suggest" : ""}`, window.location.origin);
                if (!rewritten) {
                    url.searchParams.set("q", q);
                    url.searchParams.set("section_id", "predictive-search");
                    url.searchParams.set("resources[limit]", "10");
                    url.searchParams.set("resources[limit_scope]", "each");
                }
                const html = await (await fetch(url.toString(), {
                    signal: signal
                })).text();
                const tempDoc = new DOMParser().parseFromString(html, "text/html");
                const section = tempDoc.querySelector(".shopify-section");
                const resultsSlot = el.querySelector('[slot="results"]');
                if (!section || !resultsSlot) return;
                el.shadowRoot.innerHTML = '<slot name="results"></slot>';
                resultsSlot.replaceChildren(...document.importNode(section, true).children);
            } catch (e) {
                e?.name;
            } finally{
                document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", {
                    bubbles: true
                }));
            }
        }
        const debouncedSearch = (q)=>{
            window.clearTimeout(debounceTimer);
            debounceTimer = window.setTimeout(()=>{
                runPredictiveSearch(q);
            }, 280);
        };
        document.addEventListener("input", (event)=>{
            const input = event.target;
            if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLTextAreaElement)) return;
            const form = input.form;
            if (!form || form.id !== "predictive-search-form" || input.name !== "q") return;
            // Stop the theme <predictive-search> listener (bubble) from fetching.
            event.stopImmediatePropagation();
            const q = input.value.trim();
            if (!q) {
                window.clearTimeout(debounceTimer);
                abortController?.abort();
                showPlaceholder(predictiveElement());
                return;
            }
            debouncedSearch(q);
        }, true);
    }
    document.addEventListener("submit", (event)=>{
        const form = event.target;
        if (!isThemeSearchForm(form)) return;
        event.preventDefault();
        event.stopPropagation();
        handleSearchSubmit(form).then((handled)=>{
            if (!handled) form.submit();
        });
    }, true);
    interceptPredictiveSearchInput();
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        restoreDisplayQuery();
        hydrateSearchCollectionProducts();
    }, {
        once: true
    });
    else {
        restoreDisplayQuery();
        hydrateSearchCollectionProducts();
    }
    // Warm the filter index so the first drawer keystroke is fast.
    ensurePhraseIndex();
})();



})();
//# sourceMappingURL=parcel_scripts.js.map
